import { StyleSheet } from 'react-native'
import theme from '../../../theme'

const styles = StyleSheet.create({
    divider: {
        height: 1,
        marginTop: 3,
    },
    container: {
        height: 30,
        marginHorizontal: 10,
    },
    containerLabels: {
        height: 40,
        justifyContent: 'center',
        marginHorizontal: 4,
    },
    containerStoreFormMV: {
        marginHorizontal: 12,
    },
    flatFlags: {
        flexDirection: 'row',
        borderRadius: 10,
        borderWidth: 0.5,
        borderColor: theme.colors.colorPrimary,
        paddingHorizontal: 10,
        height: 40,
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
    },
    flatItemsSelected: {
        fontWeight: 'bold',
        fontSize: 16,
        color: 'white',
    },
    flatItemsUnselected: {
        fontWeight: 'bold',
        fontSize: 16,
        color: theme.colors.colorPrimary,
    },
    flatItemsLocked: {
        fontWeight: 'bold',
        fontSize: 16,
        color: theme.colors.textSecondary,
    },
    image: {
        width: 18,
        height: 18,
        marginLeft: -2,
        marginRight: 6,
    },
    icon: {
        marginLeft: -2,
        marginRight: 6,
    },
    name: {
        fontWeight: 'normal',
        fontSize: 16,
        color: theme.colors.textSecondary,
        marginBottom: 4,
    },
    survey: {
        fontWeight: 'bold',
        fontSize: 16,
        color: theme.colors.textPrimary,
    },
})

export default styles
